module.exports = "<div class=\"row bgHeading\"><h2>Some of our fantastic sponsors</h2></div>\n<div class=\"col-12\">\n  <div class=\"col-12\" [innerHtml]=\"intro\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/sponsors/sponsors.component.html
// module id = 329
// module chunks = 1